import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Theme } from '@lux/components-gomo';
import { noop } from '@lux/helpers';
import { Button } from '../../components/tracked-components';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${Theme.media.md`
    justify-content: flex-start;
  `}
`;

const StyledButton = styled(Button)`
  padding: 0 40px;
  width: auto;
`;

const NavControls = props => {
  const {
    disableNextButton,
    nextButtonText,
    onNextButtonClick,
    trackEventNextButton,
    fullWidth
  } = props;

  return (
    <ButtonContainer data-testid="testNextButton">
      <StyledButton
        disabled={disableNextButton}
        onClick={onNextButtonClick}
        trackEvent={trackEventNextButton}
        fullWidth={fullWidth}
      >
        {nextButtonText}
      </StyledButton>
    </ButtonContainer>
  );
};

NavControls.defaultProps = {
  disableNextButton: false,
  onNextButtonClick: noop,
  nextButtonText: 'NEXT',
  fullWidth: false
};

NavControls.propTypes = {
  /** If the next button should be disabled */
  disableNextButton: PropTypes.bool,
  /** event handler for next button */
  onNextButtonClick: PropTypes.func,
  /** Next button text*/
  nextButtonText: PropTypes.string,
  /** Next button trackevent*/
  trackEventNextButton: PropTypes.object,
  /** Take the full width of parent */
  fullWidth: PropTypes.bool
};

export default NavControls;
